export default "/_next/static/fonts/Honey-BoldBanner-29360f6aedb194eef3ed8222b5a4ceae.woff";